import Search from "@arcgis/core/widgets/Search";
export function createSearch(settings) {
    const searchWidget = new Search({
        view: settings.view
    });
    // Adds the search widget below other elements in
    // the top left corner of the view
    settings.view.ui.add(searchWidget, {
        position: settings.widgetPosition
    });
}
